import React, { useEffect, useState } from 'react';
import { Outlet, Route, Routes, useLocation } from "react-router-dom";
import './App.scss';
//import Login from './components/sharedComponent/login/Login';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { title } from 'constants/title';
import Home from 'screens/menu/home/Home';
import MembershipBenifits from 'screens/menu/membershipBenifits/MembershipBenifits';
import AboutUs from 'screens/menu/aboutUs/AboutUs';
import EventAndConferences from 'screens/menu/eventAndConference/EventAndConference';
import LandingPage from 'screens/sharedScreen/LandingPage';
import ContactUs from 'screens/menu/contactUs/ContactUs';
import Verticals from 'screens/menu/verticals/Verticals';
import FAQs from 'screens/menu/faqs/FAQs';
import TermsAndConditions from 'screens/menu/terms-and-conditions/TermsAndConditions';
import PrivacyPolicies from 'screens/menu/privacyPolicies/PrivacyPolicies';
import CookiePolicies from 'screens/menu/cookiePolicies/CookiePolicies';
import Blog from 'screens/menu/blog/Blog';
import BlogDetails from 'screens/menu/blogDetails/BlogDetails';
import NewsAndMedia from 'screens/menu/news-and-media/NewsAndMedia';
import NewsAndMediaDetails from 'screens/menu/news-and-media-details/NewsAndMediaDetails';
import CSR from 'screens/menu/csr/CSR';
import CSRDetails from 'screens/menu/csrDetails/CSRDetails';
import Conferences from 'screens/menu/Conferences/conferences';
import MembershipForm from 'screens/menu/membershipBenifits/MembershipForm';
import PreviousEvents from 'screens/menu/eventAndConference/PreviousEvents';
import UpcomingEvents from 'screens/menu/eventAndConference/UpcomingEvents';
import { Accrediations } from 'screens/menu/accrediations/Accrediations';
import { Advisor } from 'screens/menu/board-of-advisor/Advisor';
import MembershipCenter from 'screens/menu/membershipCenter/MembershipCenter';
import EventGallery from 'screens/menu/eventAndConference/EventGallery';
import Newsletter from 'screens/menu/news-and-media/Newsletter';
import Conference2026 from 'screens/menu/Conferences/Conference2026';



function App() {

  const [pageTitle, setPageTitle] = useState('');
  const location = useLocation();
  const preTitle = '1WN, One World One Network';



  useEffect(() => {
    displayTitle();
  }, [location])


  function displayTitle() {
    const crumbArray = location.pathname.split('/');
    const endPoint = crumbArray[crumbArray.length - 1];
    const displayTitle = title.filter(item => {
      return item.key === endPoint;
    })
    setPageTitle(displayTitle[0] ? preTitle + ' - ' + displayTitle[0].value : preTitle);
  }

  return (

    <div className="App">
      <HelmetProvider>
        <Helmet>
          <script src="js/onpoint.js" type="text/javascript" />
          <title>{pageTitle}</title>
        </Helmet>
        <AppRoutes />
      </HelmetProvider>
    </div>

  );
}

const SuspenseLayout = () => (
  <React.Suspense fallback={<>Loading...</>}>
    <Outlet />
  </React.Suspense>
);

function AppRoutes() {
  return (

    <>
      <Routes>
        <Route exact path='/' element={<LandingPage />}>
          <Route exact path='' element={<Home />} />
          <Route exact path='membership-benifits' element={<MembershipBenifits />} />
          <Route exact path='about-us' element={<AboutUs />} />
          <Route exact path='event-and-conference' element={<EventAndConferences />} />
          <Route exact path='contact' element={< ContactUs />} />
          <Route exact path='verticals' element={<Verticals />} />
          <Route exact path='post-event-gallery' element={<EventGallery />} />
          <Route exact path='faqs' element={<FAQs />} />
          <Route exact path='terms-and-conditions' element={<TermsAndConditions />} />
          <Route exact path='privacy-policies' element={<PrivacyPolicies />} />
          <Route exact path='cookie-policies' element={<CookiePolicies />} />
          <Route exact path='blog' element={<Blog />} />
          <Route path="/blog-details/:blogId" element={<BlogDetails />} /> {/* Add this route */}
          <Route exact path='news-and-media' element={<NewsAndMedia />} />
          <Route exact path='newsletter' element={<Newsletter />} />
          <Route exact path='news-and-media-details' element={<NewsAndMediaDetails />} />
          <Route exact path='csr' element={<CSR />} />
          <Route exact path='csr-details' element={<CSRDetails />} />
          <Route exact path='conferences' element={<Conferences />} />
          <Route exact path='membership-registration' element={<MembershipForm />} />
          <Route exact path='upcoming-events' element={<UpcomingEvents />} />
          <Route exact path='previous-events' element={<PreviousEvents />} />
          <Route exact path='accrediations' element={<Accrediations />} />
          <Route exact path='board-of-advisor' element={<Advisor />} />
          <Route exact path='membership-center' element={<MembershipCenter />} />
          <Route exact path= 'conference-2026' element ={<Conference2026 />}/>
          
          
          
        </Route>
      </Routes >
    </>

  )
}

export default App;
